// Stylesheets
import './assets/scss/site.scss';

import { hover } from './assets/modules/hover';
import { externalLink } from './assets/modules/externalLink';
import { accordion } from './assets/modules/accordion';
import { countdown } from './assets/modules/countdown';
import { timeToColor } from './assets/modules/timeToColor';
import { logoAnimation } from './assets/modules/logoAnimation';
import { trigger } from './assets/modules/trigger';
import { scrollFading } from './assets/modules/scrollFading';
import { exhibitors } from './assets/modules/exhibitors';
import { swiperCarousel } from './assets/modules/swiperCarousel';
import { fluidvideo } from './assets/modules/fluidvideo';
import { initPhotoSwipeFromDOM } from './assets/modules/photoswipe-init';
import { pushStateHandler } from './assets/modules/pushState';

const init = () => {
  hover();
  trigger();
  externalLink();
  accordion();
  countdown();
  timeToColor();
  logoAnimation();
  scrollFading();
  exhibitors();
  swiperCarousel();
  fluidvideo();
  initPhotoSwipeFromDOM('.js-pswp-container');
  pushStateHandler();
  document.body.classList.add('is-init')
}

init();